import { H4 } from "components/ui/typography/titles/Titles"
import { ModelNumberOrderTip } from "components/ui/modelNumberOrderTip/ModelNumberOrderTip"
import { ModelNumberOrderHint } from "components/ui/modelNumberOrderHint/ModelNumberOrderHint"
import style from "./ModelNumberOrderInfo.module.scss"

const { heading, title } = style

type Props = { className?: string }

// "Model numbers" section title + the explanation of what their order means (REQ-457..459).
export const ModelNumberOrderInfo = ({ className = "" }: Props) => (
	<div className={className}>
		<div className={heading}>
			<H4 className={title}>Model numbers</H4>
			<ModelNumberOrderTip />
		</div>
		<ModelNumberOrderHint>
			Processing picks the first model number in this order that matches the detected object. Drag tags to reorder.
		</ModelNumberOrderHint>
	</div>
)
